import {config} from '../../utils.js';

export class BIModel {
    #eventName;
    #userId;
    #countryUser;

    constructor( eventName, userId = null ) {
        this.#eventName = eventName;
        this.#userId = userId;
        this.#countryUser = config.user?.country_iso;
    }

    get eventName() {
        return this.#eventName;
    }

    get userId() {
        return this.#userId || null;
    }

    get modelData() {
        throw new Error('You have to implement getModelData method in ' + this.eventName + ' model');
    }

    get request() {
        return {
            event: this.eventName,
            ...(this.userId && { user_id: this.userId }),
            country_user: this.#countryUser,
            ...(Object.keys(this.modelData).length > 0 && { data: this.modelData })
        }
    };

}